<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid">
	<div class="FormGrid">
		<label>Description:</label>
		<input class="form-control" type="text" placeholder="Enter name of School Day" [(ngModel)]="Desc" />

		<label>Default Bell Schedule</label>
		<select class="form-control" name="BellScheduleID" [(ngModel)]="BellScheduleID">
			<option *ngFor="let r of lstBellSchedule" [ngValue]="r.BellScheduleID">
				{{ r.BellScheduleDesc }}
			</option>
		</select>
	</div>
</div>
<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
